package de.emgress.baskets.modules.components

import androidx.compose.runtime.Composable
import core.utils.TimeUtils
import de.emgress.baskets.core.styles.Styles
import dtos.games.outgoing.GameInfoDTOOut
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun GameDayInformation(
    gameDay: Int,
    gameInfoDTO: GameInfoDTOOut,
    inlineText: Boolean = false
) {
    val timeUtils = TimeUtils()

    P({
        classes(Styles.cssClasses.paragraph, Styles.cssClasses.bold, Styles.cssClasses.barlowFont)
    }) {
        Text("Spieltag $gameDay")
    }
    if (inlineText) {
        P({
            classes(Styles.cssClasses.paragraph, Styles.cssClasses.barlowFont, Styles.cssClasses.horizontalDynamicMarginSmall)
        }) {
            Text("|")
        }
    }
    P({ classes(Styles.cssClasses.paragraph, Styles.cssClasses.barlowFont) }) {
        Text(timeUtils.timeMillisToExtendedDateString(gameInfoDTO.mDateAndTime))
    }
    if (inlineText) {
        P({
            classes(Styles.cssClasses.paragraph, Styles.cssClasses.barlowFont, Styles.cssClasses.horizontalDynamicMarginSmall)
        }) {
            Text("|")
        }
    }
    P({ classes(Styles.cssClasses.paragraph, Styles.cssClasses.barlowFont) }) {
        Text("${timeUtils.timeMillisToTimeString(gameInfoDTO.mDateAndTime)} Uhr")
    }
}